<template>
  <div
    class="spinner ed-spinner ed-spinner--top">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {},
  data() {
    return {};
  },
  created() {
  },
  mounted() {
  },
  methods: {},
  computed: {},
  watch: {},
};
</script>
